import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import moment from 'moment'
import { Spin, message } from 'antd'
import { cloneDeep } from 'lodash'
import Icon from 'meinian-package/src/component/icon'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import request from 'meinian-package/src/utils/request'
import Button from 'meinian-package/src/baseComponent/button'
import { useRequest } from 'ahooks'
import { CONFIG_KEY, OPTION_ITEM_TYPE, SOURCE_TYPE, DY_CONFIG, getPlatformConfig } from './config'
import ModuleItem from '../detail/moduleItem'
import styles from './index.module.less'

const qs = (obj) => {
  const search = []
  for (const key in obj) {
    if (obj[key] !== undefined) {
      search.push(`${key}=${encodeURIComponent(obj[key])}`)
    }
  }
  return search.join('&')
}

export const hasFromData = (cur: any, val, dto) => {
  if (typeof cur === 'object' && Object.prototype.hasOwnProperty.call(cur, 'fromData')) {
    return cur.fromData(val, dto)
  }
  return val
}

const hasCustomizeFromData = (cur: any, cusVal, val) => {
  if (typeof cur === 'object' && Object.prototype.hasOwnProperty.call(cur, 'customizeFromData')) {
    return cur.customizeFromData(cusVal)
  }
  return val
}

const hasSourceType = (cur, dto, curItem) => {
  if (cur.type === SOURCE_TYPE.DTO) {
    return dto
  }
  return curItem
}

const isHidden = (item, dto, currentImage) => {
  if (!item) {
    return true
  }
  return typeof item.hidden === 'function' ? item.hidden(dto, currentImage) : item.hidden
}

const HIDDEN_DETAIL_AND_SOURCE_PLATFORM_IDS = [
  PLATFORM_VALUE.XIAOHONGSHU,
  PLATFORM_VALUE.ZHI_XIAO_HONG,
  PLATFORM_VALUE.ZXH_ITEM,
].map(Number)

export default ({ currentImage }) => {
  const platformId = Number(currentImage?.platformId)
  const { config, dtoConfig } = getPlatformConfig(platformId, currentImage?.isFromZkPlatform)
  const dto = currentImage?.[dtoConfig?.dto]
  if (!dto) return null

  const keys = config ? Object.keys(config) : []
  const displayKeys = HIDDEN_DETAIL_AND_SOURCE_PLATFORM_IDS.includes(platformId)
    ? keys.filter((key) => key === CONFIG_KEY.TITLE)
    : keys
  const onOriginLink = async (dataSource: any) => {
    if (!dataSource.linkUrl) {
      return
    }
    const _query = {}
    if (dataSource?.query) {
      Object.keys(dataSource?.query).forEach((queryKey) => {
        _query[queryKey] = dto[dataSource.query[queryKey]]
      })
    }
    if (typeof dataSource.linkUrl === 'function') {
      dataSource.linkUrl(dto, currentImage)
    } else {
      const link = dataSource.defaultQuery
        ? `${dataSource.linkUrl}?${qs(_query)}${dataSource.defaultQuery}`
        : `${dataSource.linkUrl}?${qs(_query)}`
      window.open(link)
    }
  }

  const onOriginTextLink = async (dataSource: any) => {
    const _query = {}
    if (dataSource?.query) {
      Object.keys(dataSource.query).forEach((queryKey) => {
        _query[queryKey] = dataSource.type === SOURCE_TYPE.DTO ? dto[dataSource.query[queryKey]] : currentImage[dataSource.query[queryKey]]
      })
    }
    if (typeof dataSource.linkUrl === 'function') {
      dataSource.linkUrl(dto, currentImage)
    } else {
      const link = `${dataSource.linkUrl}?${qs(_query)}`
      window.open(link)
    }
  }

  return (
    <div className={styles.infoBlock}>
      <div className={styles.titleLine}>
        <div className={styles.point} />
        <div className={styles.mainTitle}>原文信息</div>
      </div>
      {platformId === PLATFORM_VALUE.DY && (
        <DY dto={dto} dtoConfig={dtoConfig} currentImage={currentImage} onOriginTextLink={onOriginTextLink} />
      )}
      {dto?.platformType === '9' && (
        <SHOP1688
          config={config}
          dtoConfig={dtoConfig}
          keys={keys}
          dto={dto}
          currentImage={currentImage}
          onOriginTextLink={onOriginTextLink}
        />
      )}
      {!(platformId === PLATFORM_VALUE.DY || dto?.platformType === '9') && (
        <div className={styles.infoBlockContext}>
          {displayKeys.map((key) => (
            <Template
              configKey={key}
              config={config}
              dtoConfig={dtoConfig}
              keys={displayKeys}
              key={key}
              dto={dto}
              currentImage={currentImage}
              onOriginLink={onOriginLink}
              onOriginTextLink={onOriginTextLink}
            />
          ))}
        </div>
      )}
    </div>
  )
}

const SHOP1688 = ({ config: wrapConfig, dtoConfig, keys, dto, currentImage, onOriginTextLink }) => {
  const config = cloneDeep(wrapConfig)
  if (config.ORIGIN_LINK[0].type) {
    config.ORIGIN_LINK[0].type = '店铺'
  }
  const _platformId = String(dto.platformId).substring(1)
  const { data: shopInfo, loading } = useRequest(() => request.get(`/backend-api/abroad-dataline/goods/detail?platformType=${_platformId}&productId=${dto.productId}`))
  const _dto = { ...dto, shopInfo }
  const onOriginLink = (dataSource) => {
    if (!dataSource.linkUrl) {
      return
    }
    const _query = {}

    if (dataSource?.query) {
      Object.keys(dataSource?.query).forEach((queryKey) => {
        _query[queryKey] = _dto[dataSource.query[queryKey]]
      })
    }

    if (typeof dataSource.linkUrl === 'function') {
      dataSource.linkUrl(_dto, currentImage)
    } else {
      const link = dataSource.defaultQuery
        ? `${dataSource.linkUrl}?${qs(_query)}${dataSource.defaultQuery}`
        : `${dataSource.linkUrl}?${qs(_query)}`
      window.open(link)
    }
  }

  return (
    <Spin spinning={loading}>
      <div className={styles.infoBlockContext}>
        {keys.map((key) => (
          <Template
            configKey={key}
            config={config}
            dtoConfig={dtoConfig}
            keys={keys}
            key={key}
            dto={{ ...dto, shopInfo }}
            currentImage={currentImage}
            onOriginLink={onOriginLink}
            onOriginTextLink={onOriginTextLink}
          />
        ))}
      </div>
    </Spin>
  )
}

const DY = ({ dto, dtoConfig, currentImage, onOriginTextLink }) => {
  const [hostId, setHostId] = useState()
  const [relateStreamerName, setRelateStreamerName] = useState('')
  useEffect(() => {
    fetchHostInfo()
  }, [dto.shopId])

  const fetchHostInfo = async () => {
    const res: any = await request.get('/v1-0-7/douyin/shop/info', { params: { shopId: dto.shopId } })
    setHostId(res.relateStreamerId)
    setRelateStreamerName(res.relateStreamerName)
  }

  const _config = hostId ? DY_CONFIG[0] : DY_CONFIG[1]
  const keys = _config ? Object.keys(_config) : []
  const _dto = { ...dto, relateStreamerName, hostId }

  const onOriginLink = (dataSource) => {
    if (!dataSource.linkUrl) {
      return
    }
    const _query = {}

    if (dataSource?.query) {
      Object.keys(dataSource?.query).forEach((queryKey) => {
        _query[queryKey] = _dto[dataSource.query[queryKey]]
      })
    }

    if (typeof dataSource.linkUrl === 'function') {
      dataSource.linkUrl(_dto, currentImage)
    } else {
      const link = dataSource.defaultQuery
        ? `${dataSource.linkUrl}?${qs(_query)}${dataSource.defaultQuery}`
        : `${dataSource.linkUrl}?${qs(_query)}`
      window.open(link)
    }
  }

  return (
    <div className={styles.infoBlockContext}>
      {keys.map((key) => (
        <Template
          configKey={key}
          config={_config}
          dtoConfig={dtoConfig}
          key={key}
          keys={keys}
          dto={_dto}
          currentImage={currentImage}
          onOriginLink={onOriginLink}
          onOriginTextLink={onOriginTextLink}
        />
      ))}
    </div>
  )
}

const Template = ({ keys, configKey, dto, dtoConfig, config, currentImage, onOriginLink, onOriginTextLink }) => {
  const originLinkConfig = configKey === CONFIG_KEY.ORIGIN_LINK ? config[configKey] : []
  const originLinkLeft = originLinkConfig?.[0]
  const originLinkRight = originLinkConfig?.[1]
  const showOriginLinkLeft = !isHidden(originLinkLeft, dto, currentImage)
  const showOriginLinkRight = !isHidden(originLinkRight, dto, currentImage)

  const getOptionItemValue = (item) => {
    if (item.type === OPTION_ITEM_TYPE.CUSTOM) {
      return item?.fromData ? item.fromData(dto) : dto?.[item.valueKey]
    }
    if (item.type === OPTION_ITEM_TYPE.DTO) {
      return hasSourceType(item.type, dto, currentImage)[item.valueKey]
    }
    if (item.type === OPTION_ITEM_TYPE.TIME) {
      return moment(dto[item.valueKey]).format('YYYY/MM/DD HH:mm:ss')
    }
    if (item.type === OPTION_ITEM_TYPE.DATA) {
      return moment(hasSourceType(item.type, dto, currentImage)[item.valueKey]).format('YYYY/MM/DD')
    }
  }
  return (
    <>
      {configKey === CONFIG_KEY.TITLE && (
        <div
          className={classNames(styles.originalTextInfoTitle, 'text-overflow', {
            'cursor-pointer': config[configKey].linkUrl,
            [styles['link-btn']]: config[configKey].linkUrl,
          })}
          style={{ marginBottom: keys.some((item) => item === CONFIG_KEY.PRICE) ? '4px' : '12px' }}
          onClick={() => onOriginLink(config[configKey])}
        >
          {hasCustomizeFromData(config[configKey], dto, dto[config[configKey].labelKey])}
        </div>
      )}
      {configKey === CONFIG_KEY.PRICE && (
        <div className={styles.originalTextInfoPrice}>
          {config[configKey][0] && (
            <div className={styles.currentPrice}>
              {hasFromData(config[configKey][0], dto[config[configKey][0].valueKey], dto)}
            </div>
          )}
          {config[configKey][1] && (
            <div className={styles.historyPrice}>
              {config[configKey][1].label || '历史最低价：'}
              {hasFromData(config[configKey][1], dto[config[configKey][1].valueKey], dto)}
            </div>
          )}
        </div>
      )}
      {configKey === CONFIG_KEY.INFO_BLOCK && (
        <div className={styles.originalTextInfoDetail}>
          <div className={styles.originalTextInfoDetailCardWrap}>
            {config[configKey].map((item) => (
              <div className={classNames(styles.originalTextInfoDetailCard)}>
                {Array.isArray(item.valueKey) ? (
                  <>
                    <div className={styles.originalTextInfoDetailCardTitle}>{item.label}</div>
                    <div className={styles.originalTextInfoDetailCardData}>
                      {hasFromData(item, dto[item.valueKey[0]], dto)}
                      <span style={{ color: 'var(--m-text-2)', fontWeight: 400 }}>
                        /{hasFromData(item, dto[item.valueKey[1]], dto)}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.originalTextInfoDetailCardTitle}>{item.label}</div>
                    <div className={styles.originalTextInfoDetailCardData}>{hasFromData(item, dto[item.valueKey], dto)}</div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {configKey === CONFIG_KEY.EXTERNAL_LINK && (
        <div className={classNames(styles.originalTextInfoExternalLink)}>
          站外
          <div>
            {config[configKey].map((item) => (
              <Button
                onClick={() => onOriginLink(item)}
                type="link"
                className={classNames(styles.originalTextInfoExternalLinkBtn)}
              >
                <div className={classNames('text-overflow')} style={{ maxWidth: '120px' }}>
                  {item.label || hasCustomizeFromData(item, dto, dto[item.labelKey])}
                </div>
                <div className={styles.rightIcon}>
                  <Icon type="m-Vxing_you" />
                </div>
              </Button>
            ))}
          </div>
        </div>
      )}
      {configKey === CONFIG_KEY.ORIGIN_LINK && (showOriginLinkLeft || showOriginLinkRight) && (
        <div className={styles.originalTextInfoInspiration}>
          站内
          <span className={styles.originalTextInfoInspirationWrap}>
            {showOriginLinkLeft && (
              <span
                onClick={() => {
                  if (originLinkLeft.message) {
                    message.info(originLinkLeft.message)
                  } else {
                    onOriginLink(originLinkLeft)
                  }
                }}
              >
                <Button
                  type="link"
                  disabled={originLinkLeft.message}
                  className={classNames(styles.originalTextInfoInspirationLeft)}
                >
                  <div className={styles.label}>
                    {originLinkLeft?.customizeTypeKey
                      ? dto[originLinkLeft.customizeTypeKey]
                      : originLinkLeft.type}
                    ：
                  </div>
                  <div className={classNames(styles.value, 'text-overflow')}>
                    {hasCustomizeFromData(originLinkLeft, dto, dto[originLinkLeft.labelKey])}
                  </div>
                  <div className={styles.rightIcon}>
                    <Icon type="m-Vxing_you" />
                  </div>
                </Button>
              </span>
            )}
            {showOriginLinkRight && (
              <span
                onClick={() => {
                  if (originLinkRight.message) {
                    message.info(originLinkRight.message)
                  } else {
                    onOriginTextLink(originLinkRight)
                  }
                }}
              >
                <Button
                  type="link"
                  disabled={originLinkRight.message}
                  className={classNames(styles.originalTextInfoInspirationRight)}
                >
                  {originLinkRight?.label}原文
                  <div className={styles.rightIcon}>
                    <Icon type="m-Vxing_you" />
                  </div>
                </Button>
              </span>
            )}
          </span>
        </div>
      )}
      {configKey === CONFIG_KEY.OPTION_ITEM && (
        <>
          <ModuleItem
            label="款式来源"
            mb12={false}
            style={{ marginBottom: '8px' }}
            value={dtoConfig?.label || currentImage[dtoConfig?.labelKey] || hasFromData(dtoConfig, currentImage, dto)}
          />
          {config[configKey].map((item) => {
            if (item?.label || dto?.[item?.labelKey]) {
              return (
                <ModuleItem
                  label={item?.label || dto?.[item?.labelKey]}
                  mb12={false}
                  style={{ marginBottom: '8px' }}
                  value={getOptionItemValue(item)}
                />
              )
            }
            return null
          })}
        </>
      )}
    </>
  )
}
